const CMS_ONLY_DASHBOARD_PATH = '/dashboard/settings';

/** Resolve the staff landing page for the apps enabled on the current site. */
export const resolveDashboardHomePath = (apps: readonly string[]): string => {
  if (apps.includes('erp') || apps.includes('crm')) {
    return '/erp';
  }

  if (apps.includes('eshop')) {
    return '/eshop/dashboard';
  }

  if (apps.includes('cms')) {
    return CMS_ONLY_DASHBOARD_PATH;
  }

  return '/cms/account';
};
